var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('simple-page', {
    scopedSlots: _vm._u([{
      key: "pageItem",
      fn: function fn() {
        return [_c('breadcrumb', {
          attrs: {
            "items": _vm.breadcrumbItems
          }
        })];
      },
      proxy: true
    }, {
      key: "pageTitle",
      fn: function fn() {
        return [_c('div', {
          staticClass: "titleBtn"
        }, [_c('h1', [_vm._v("Manage Menu")])])];
      },
      proxy: true
    }, {
      key: "topPagination",
      fn: function fn() {
        return [_c('div', {
          staticClass: "filter-field text-end mb-3"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.filters.query,
            expression: "filters.query"
          }],
          staticClass: "custom-input",
          attrs: {
            "type": "text",
            "placeholder": "Search (by menu name)"
          },
          domProps: {
            "value": _vm.filters.query
          },
          on: {
            "keyup": _vm.filterMenu,
            "input": function input($event) {
              if ($event.target.composing) { return; }

              _vm.$set(_vm.filters, "query", $event.target.value);
            }
          }
        })])];
      },
      proxy: true
    }, {
      key: "table",
      fn: function fn() {
        return [_c('menu-list', {
          attrs: {
            "rows": _vm.menuList
          },
          on: {
            "onManage": _vm.getMenuDetails
          }
        }), _c('menu-form', {
          attrs: {
            "row": _vm.row
          },
          on: {
            "update:row": function updateRow($event) {
              _vm.row = $event;
            },
            "onSuccess": function onSuccess($event) {
              return _vm.getMenuList(_vm.filters);
            }
          }
        }), _c('pagination', {
          attrs: {
            "rows": _vm.menuList
          },
          on: {
            "update:rows": function updateRows($event) {
              _vm.menuList = $event;
            }
          }
        })];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }